'use strict';

export default class Switcher {
	constructor(root) {
		this.root = root;
		if (!this.root) return false;
		this._matchHTML();
		this._handler();
	}

	_matchHTML() {
		this.switches = [...this.root.querySelectorAll('[data-switcher-input]')];
		this.containers = [...this.root.querySelectorAll('[data-switcher-container]')];
	}

	_handler() {
		this.switches.forEach(input => {
			input.addEventListener('change', e => {

				if (input.checked) {
					let id = input.dataset.switcherInput;

					this.containers.forEach(container => {
						container.classList.remove('is-active');

						[...container.querySelectorAll('input')].forEach(input => {
							input.disabled = true;
						});

						if (container.dataset.switcherContainer === id) {
							container.classList.add('is-active');
							[...container.querySelectorAll('input')].forEach(input => {
								input.disabled = false;
							});
						}
					})

				}
			})
		})
	}
}
